// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2j92A","footer":"ModalInfo_footer__3fVMw"};